export const FETCH_ALL_PENDING_CONNECTIONS_REQUEST = 'FETCH_ALL_PENDING_CONNECTIONS_REQUEST';
export const FETCH_ALL_PENDING_CONNECTIONS_SUCCESS = 'FETCH_ALL_PENDING_CONNECTIONS_SUCCESS';
export const FETCH_ALL_PENDING_CONNECTIONS_FAILURE = 'FETCH_ALL_PENDING_CONNECTIONS_FAILURE';

export const FETCH_ACTIVE_CONNECTIONS_REQUEST = 'FETCH_ACTIVE_CONNECTIONS_REQUEST';
export const FETCH_ACTIVE_CONNECTIONS_SUCCESS = 'FETCH_ACTIVE_CONNECTIONS_SUCCESS';
export const FETCH_ACTIVE_CONNECTIONS_FAILURE = 'FETCH_ACTIVE_CONNECTIONS_FAILURE';

export const APPLY_INCOMING_CONNECTIONS_REQUEST = 'APPLY_INCOMING_CONNECTIONS_REQUEST';
export const APPLY_INCOMING_CONNECTIONS_SUCCESS = 'APPLY_INCOMING_CONNECTIONS_SUCCESS';
